import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-employeewise-pending-tickets',
  templateUrl: './employeewise-pending-tickets.component.html',
  styleUrls: ['./employeewise-pending-tickets.component.css']
})
export class EmployeewisePendingTicketsComponent implements OnInit {
  p:any={};
  UsersList: any=[];

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetAllInternalUsers();
  }

  EmployeewisePendingTicketsReport = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.employeewisePendingTicketsReport(this.p.FromDate,this.p.ToDate,this.p.IS_To_UserId)
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

GetAllInternalUsers() {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.getInternalUsersForDropdown()
    .subscribe(
      (data: any) => {
        this.UsersList = data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
}


Print = function () {
  window.print()
}

}



// WEBPACK FOOTER //
// ./src/app/reports/employeewise-pending-tickets/employeewise-pending-tickets.component.ts